export const BlueprintContent: any[] = [
  {
    make: 'Frictionless Commerce',
    id: 1,
    categories: [
      {
        id: 1,
        title: "Vision Checkout",
        imageUrl: 'TENANT_GENERIC_CONFIG',
        variants: [
          {
            model: "SmartSKU-5025",
            brand: 'UST',
            category: 'Vision Checkout',
            variant: 'Gen 3',
            renewedYear: '2023',
            launchedDate: '05 Oct 2022',
            productionEndDate: '05 Nov 2022',
            saleCeasedDate: '05 Dec 2022',
            componentList: [],
            ontology: {
              url: 'TENANT_GENERIC_CONFIG'
            },
            image: {
              url: "TENANT_GENERIC_CONFIG",
            }
          },
          {
            model: "SmartSKU-5025",
            brand: 'UST',
            category: 'Vision Checkout',
            variant: 'Gen 2',
            renewedYear: '2022',
            launchedDate: '05 Oct 2021',
            productionEndDate: '05 Nov 2021',
            saleCeasedDate: '05 Dec 2021',
            componentList: [],
            ontology: {
              url: 'TENANT_GENERIC_CONFIG'
            },
            image: {
              url: "TENANT_GENERIC_CONFIG",
            }
          },
          {
            model: "SmartSKU-5025",
            brand: 'UST',
            category: 'Vision Checkout',
            variant: 'Gen 1',
            renewedYear: '2021',
            launchedDate: '05 Oct 2020',
            productionEndDate: '05 Nov 2020',
            saleCeasedDate: '05 Dec 2020',
            componentList: [],
            ontology: {
              url: 'TENANT_GENERIC_CONFIG'
            },
            image: {
              url: "TENANT_GENERIC_CONFIG",
            }
          }
        ]
      },
      // {
      //   id: 2,
      //   title: "WalkIn-WalkOut",
      //   imageUrl: 'TENANT_GENERIC_CONFIG',
      //   variants: [
      //     {
      //       model: "Gen 2",
      //       brand: 'UST',
      //       category: 'WalkIn-WalkOut',
      //       variant: 'Gen 1',
      //       renewedYear: '2021',
      //       launchedDate: '05 Oct 2020',
      //       productionEndDate: '05 Nov 2020',
      //       saleCeasedDate: '05 Dec 2020',
      //       componentList: [],
      //       ontology: {
      //         url: 'TENANT_GENERIC_CONFIG'
      //       },
      //       image: {
      //         url: 'TENANT_GENERIC_CONFIG'
      //       }
      //     }
      //   ]
      // },
      {
        id: 3,
        title: "Cold Storage",
        imageUrl: 'TENANT_GENERIC_CONFIG',
        variants: [
          {
            model: "Coldra-2018",
            brand: 'UST',
            category: 'Cold Storage',
            variant: 'Gen 1',
            renewedYear: '2021',
            launchedDate: '05 Oct 2020',
            productionEndDate: '05 Nov 2020',
            saleCeasedDate: '05 Dec 2020',
            componentList: [],
            ontology: {
              url: 'TENANT_GENERIC_CONFIG'
            },
            image: {
              url: 'TENANT_GENERIC_CONFIG'
            }
          }
        ]
      },
      {
        id: 4,
        title: "Product Box",
        imageUrl: 'TENANT_GENERIC_CONFIG',
        variants: [
          {
            model: "SKU360-3014",
            brand: 'UST',
            category: 'Product Box',
            variant: 'Gen 1',
            renewedYear: '2021',
            launchedDate: '05 Oct 2020',
            productionEndDate: '05 Nov 2020',
            saleCeasedDate: '05 Dec 2020',
            componentList: [],
            ontology: {
              url: 'TENANT_GENERIC_CONFIG'
            },
            image: {
              url: 'TENANT_GENERIC_CONFIG'
            }
          }
        ]
      }
    ]
  },
  // {
  //   make: 'Other',
  //   id: 2,
  //   categories: [
  //     {
  //       id: 5,
  //       title: "Vision Checkout 2",
  //       imageUrl: 'TENANT_GENERIC_CONFIG',
  //       variants: [
  //         {
  //           model: "SmartSKU-5025",
  //           brand: 'UST',
  //           category: 'Vision Checkout',
  //           variant: 'Gen 1',
  //           renewedYear: '2021',
  //           launchedDate: '05 Oct 2020',
  //           productionEndDate: '05 Nov 2020',
  //           saleCeasedDate: '05 Dec 2020',
  //           componentList: [],
  //           ontology: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           },
  //           image: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       id: 6,
  //       title: "WalkIn-WalkOut 2",
  //       imageUrl: 'TENANT_GENERIC_CONFIG',
  //       variants: [
  //         {
  //           model: "Gen 2",
  //           brand: 'UST',
  //           category: 'WalkIn-WalkOut',
  //           variant: 'Gen 1',
  //           renewedYear: '2021',
  //           launchedDate: '05 Oct 2020',
  //           productionEndDate: '05 Nov 2020',
  //           saleCeasedDate: '05 Dec 2020',
  //           componentList: [],
  //           ontology: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           },
  //           image: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       id: 7,
  //       title: "Cold Storage 2",
  //       imageUrl: 'TENANT_GENERIC_CONFIG',
  //       variants: [
  //         {
  //           model: "Coldra-2018",
  //           brand: 'UST',
  //           category: 'Cold Storage',
  //           variant: 'Gen 1',
  //           renewedYear: '2021',
  //           launchedDate: '05 Oct 2020',
  //           productionEndDate: '05 Nov 2020',
  //           saleCeasedDate: '05 Dec 2020',
  //           componentList: [],
  //           ontology: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           },
  //           image: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       id: 8,
  //       title: "Product Box 2",
  //       imageUrl: 'TENANT_GENERIC_CONFIG',
  //       variants: [
  //         {
  //           model: "SKU360-3014",
  //           brand: 'UST',
  //           category: 'Product Box',
  //           variant: 'Gen 1',
  //           renewedYear: '2021',
  //           launchedDate: '05 Oct 2020',
  //           productionEndDate: '05 Nov 2020',
  //           saleCeasedDate: '05 Dec 2020',
  //           componentList: [],
  //           ontology: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           },
  //           image: {
  //             url: 'TENANT_GENERIC_CONFIG'
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // }
];

export const RecentActivityContent: any[] = [
  {
    title: 'Product Box',
    description: 'New variant added',
    updatedDate: '2024-04-09T13:54:38.000+0000',
    status: {
      type: "added",
      title: "Added",
      colorCode: "#1F9254",
      backgroundColorCode: "#EBF9F1"
    }
  },
  {
    title: 'WalkIn-WalkOut',
    description: 'Variant updated',
    updatedDate: '2024-04-08T13:54:38.000+0000',
    status: {
      type: "edited",
      title: "Edited",
      colorCode: "#b1c309",
      backgroundColorCode: "#FFC55526"
    }
  },
  {
    title: 'Vision Checkout',
    description: 'New variant added',
    updatedDate: '2024-04-07T13:54:38.000+0000',
    status: {
      type: "added",
      title: "Added",
      colorCode: "#1F9254",
      backgroundColorCode: "#EBF9F1"
    }
  },
  {
    title: 'Cold Storage',
    description: 'Variant updated',
    updatedDate: '2024-04-06T13:54:38.000+0000',
    status: {
      type: "edited",
      title: "Edited",
      colorCode: "#b1c309",
      backgroundColorCode: "#FFC55526"
    }
  },
  {
    title: 'Product Box',
    description: 'New variant added',
    updatedDate: '2024-04-05T13:54:38.000+0000',
    status: {
      type: "added",
      title: "Added",
      colorCode: "#1F9254",
      backgroundColorCode: "#EBF9F1"
    }
  },
  {
    title: 'WalkIn-WalkOut',
    description: 'Variant updated',
    updatedDate: '2024-04-04T13:54:38.000+0000',
    status: {
      type: "edited",
      title: "Edited",
      colorCode: "#b1c309",
      backgroundColorCode: "#FFC55526"
    }
  },
  {
    title: 'Vision Checkout',
    description: 'New variant added',
    updatedDate: '2024-04-03T13:54:38.000+0000',
    status: {
      type: "added",
      title: "Added",
      colorCode: "#1F9254",
      backgroundColorCode: "#EBF9F1"
    }
  },
  {
    title: 'Cold Storage',
    description: 'Variant updated',
    updatedDate: '2024-04-02T13:54:38.000+0000',
    status: {
      type: "edited",
      title: "Edited",
      colorCode: "#b1c309",
      backgroundColorCode: "#FFC55526"
    }
  }
];